
import { Observable } from './druid/./druid/Observable';
import { distinctUntilChanged } from './druid/./druid/operator/distinctUntilChanged';

Observable.prototype.distinctUntilChanged = distinctUntilChanged;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    distinctUntilChanged: typeof distinctUntilChanged;
  }
}